/*
 * File: /src/services/tagService.js
 * Created Date: Saturday November 14th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 14th November 2020 8:48:30 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_TAGS_PATH } from '../constants';

export default {
  /**
   * Fetch Tags
   */
  async fetchTags(counts) {
    return authedAxios.get(AD_BASE_TAGS_PATH, {
      params: {
        counts: counts,
        sort: 'label:asc',
      },
    });
  },

  /**
   * Save Tag
   *
   * @param {number} [id=0]
   * @param {object} Tag Object
   * @returns
   */
  async saveTag(id, body) {
    if (id) {
      return authedAxios.put(AD_BASE_TAGS_PATH + id, body)
    }
    return authedAxios.post(AD_BASE_TAGS_PATH, body);
  },

  /**
   * Delete Tag
   */
  async deleteTag(id) {
    return authedAxios.delete(AD_BASE_TAGS_PATH + id);
  },
};
